/* Click-to-play, no embedded YouTube frame before user interaction. */
(function () {
  'use strict';
  if (window.__zingEditorialVideosBound) return;
  window.__zingEditorialVideosBound = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-zing-video-play]');
    if (!button) return;
    var id = button.getAttribute('data-video-id') || '';
    if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
    var frame = button.closest('.zing-video__frame');
    if (!frame || frame.querySelector('iframe')) return;
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0';
    iframe.title = button.getAttribute('data-video-title') || 'ZingCandy YouTube Short';
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    frame.replaceChildren(iframe);
    iframe.focus();
  });
})();
